
import { Injectable } from '@angular/core';
import {  Users } from '../models/users';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { pairText } from '../models/users';
import { momDashboard } from '../models/MOMForm';
@Injectable({
  providedIn: 'root'
})
export class AdminService {

  // Define API
  apiURL ='';
  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/

  private GetHttpOptions() {
    if(localStorage.getItem('isPingUser')=='True'){
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.jwtToken(),
          'ping_un':sessionStorage.getItem('ping_un')
        })
      }
    }else{
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    }
  }
  }

  //JWT token access
  public jwtToken() {

    var struser = sessionStorage.getItem('accessinfo');
    if (struser) {
      let currentAccess = JSON.parse(struser);
      // create authorization header with jwt token           
      if (currentAccess && currentAccess.token) {
        //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        return currentAccess.token;
      }
    }
  }



  callpairText(objuser: pairText) {
    return this.http.post(this.apiURL + '/api/Login/CallpairText', objuser, this.GetHttpOptions());
  }
  SchedularCall(objuser: momDashboard) {
    return this.http.post(this.apiURL + '/api/MasterMOM/SchedularCall', objuser, this.GetHttpOptions());

  }
  //Login
  //Expert_Award Get
  AdUserAuthenticate(objusermaster: Users)
  {   
    return this.http.post(this.apiURL + '/api/Login/AuthenticateUserCap', objusermaster, this.GetHttpOptions());
  }

  pingUserAuthenticate(objusermaster: Users)
  {
    return this.http.post(this.apiURL + '/api/Login/PingAuthenticateUserCap', objusermaster, this.GetHttpOptions());
  }

  GetUserInfo_ByUserID(objusermaster: Users) {
    objusermaster.language = this.getCurrentLanguage();
    return this.http.post(this.apiURL + '/api/Login/GetUserInfo_ByUserID', objusermaster, this.GetHttpOptions());
  }

  GetUserInfo_ByUserIDPing(objusermaster: Users) {
    objusermaster.language = this.getCurrentLanguage();
    return this.http.post(this.apiURL + '/api/Login/GetUserInfo_ByUserIDPing', objusermaster, this.GetHttpOptions());
  }

  forgotPassWord(obj: Users) {
    return this.http.post(this.apiURL + '/api/Login/ForgotPassWord', obj, this.GetHttpOptions());
  }

  getCurrentLanguage() {

    //var lng = this._langService.getLang();
    //if (lng) { return lng.ISOCode; }
    //else { return 'en'; }

    return 'en';
  }

  public verifyPingAccessToken() {
    let body = new URLSearchParams();
        body.set('token', sessionStorage.getItem('momaccesstoken'));

        let options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization':'Basic '+btoa(environment.client_id+':'+environment.client_secret)                      
            })
        };

        return this.http.post(environment.verifyToken, body.toString(), options);
   
}

}
